import { PaginationRow } from "@faire/deprecated-retailer-visitor-shared/features/Marketplace/style";
import { useCategoryPagePaginationData } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useCategoryPagePaginationData";
import { getCurrentPath } from "@faire/web/common/Path";
import { Pagination } from "@faire/web/slate-deprecated/Pagination";
import React from "react";

export const CategoryPagePagination = ({
  onChangePage,
}: {
  onChangePage?: (page: number) => void;
}) => {
  const paginationData = useCategoryPagePaginationData();

  const handlePaginationLink = (pageNumber: number): string => {
    const currentFilterPath = getCurrentPath().delete("page");
    if (pageNumber === 1) {
      return currentFilterPath.toString();
    }
    return currentFilterPath.append({ page: pageNumber.toString() }).toString();
  };

  const shouldShowPagination =
    paginationData && (paginationData.page_count ?? 0) > 1;

  if (!shouldShowPagination) {
    return null;
  }

  return (
    <PaginationRow>
      <Pagination
        paginationData={paginationData}
        pageToLink={handlePaginationLink}
        onChangePage={onChangePage}
      />
    </PaginationRow>
  );
};
